module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_4.83589f93.png";